export default __webpack_public_path__ + "static/media/img8.b3a3449f.png";